import styled from "styled-components";

export const CircleIndicator = styled.div<{ $color: string }>`
  height: 9px;
  width: 9px;
  min-width: 9px;
  min-height: 9px;
  border-radius: 100px;
  background-color: ${({ $color }) => $color};
  margin: 0px auto;
`;
